import { Routes } from '@angular/router';
import { sessionGuard } from '@core/guards/Auth.guard';
import { CanDeactivateGuard } from './core/guards/CanDeactivate.guard';
import { reloadGuard } from './core/guards/reload.guard';
import { EClaimsTopPageComponent } from './features/e-claims-top-page/e-claims-top-page.component';
import { BrowserCompatibilityComponent } from './shared/components/browser-compatibility/browser-compatibility.component';
import { maintenanceGuard } from './core/guards/maintenance.guard';
import { RecommendedBrowserComponent } from './shared/components/recommended-browser/recommended-browser.component';
import { browserCompatibilityGuard } from './core/guards/browser-compatibility.guard';

export const routes: Routes = [
  // ========================================
  // Root Redirect
  // ========================================
  {
    path: '',
    redirectTo: 'eclaim',
    pathMatch: 'full'
  },

  // ========================================
  // Landing Page (No Children)
  // ========================================
  {
    path: 'eclaim',
    component: EClaimsTopPageComponent,
    canActivate: [maintenanceGuard, browserCompatibilityGuard],
    data: { scrollPositionRestoration: 'top' }
  },

  // ========================================
  // Flow Routes (Sibling Routes, Not Children)
  // ========================================
  {
    path: 'user-identification',
    loadComponent: () =>
      import('./features/authentication/authentication.component')
        .then(m => m.AuthenticationComponent),
    data: { scrollPositionRestoration: 'top' },
    canActivate: [reloadGuard, maintenanceGuard]
  },
  {
    path: 'required-document',
    loadComponent: () =>
      import('./features/required-documents-confirmation/required-documents-confirmation.component')
        .then(m => m.RequiredDocumentsConfirmationComponent),
    canActivate: [sessionGuard, reloadGuard],
    data: {
      scrollPositionRestoration: 'top',
      breadcrumb: '必要書類確認'
    }
  },
  {
    path: 'document-submission',
    loadComponent: () =>
      import('./features/document-submission/document-submission.component')
        .then(m => m.DocumentSubmissionComponent),
    canActivate: [sessionGuard, reloadGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      scrollPositionRestoration: 'top',
      breadcrumb: '書類提出'
    }
  },
  {
    path: 'medical-assessment',
    loadComponent: () =>
      import('./features/medical-condition/medical-condition.component')
        .then(m => m.MedicalConditionComponent),
    canActivate: [sessionGuard, reloadGuard],
    data: {
      scrollPositionRestoration: 'top',
      breadcrumb: '病気・ケガの状況確認'
    }
  },
  {
    path: 'bank-account',
    loadComponent: () =>
      import('./features/bank-account/bank-account.component')
        .then(m => m.BankAccountComponent),
    canActivate: [sessionGuard, reloadGuard],
    data: {
      scrollPositionRestoration: 'top',
      breadcrumb: '銀行口座'
    }
  },
  {
    path: 'address-search',
    loadComponent: () =>
      import('./features/address-search/address-search.component')
        .then(m => m.AddressSearchComponent),
    canActivate: [sessionGuard, reloadGuard],
    data: {
      scrollPositionRestoration: 'top',
      breadcrumb: '住所検索'
    }
  },
  {
    path: 'confirm-address',
    loadComponent: () =>
      import('./features/address-search-confirmation/address-search-confirmation.component')
        .then(m => m.AddressSearchConfirmationComponent),
    canActivate: [sessionGuard, reloadGuard],
    data: {
      scrollPositionRestoration: 'top',
      breadcrumb: '住所確認'
    }
  },
  {
    path: 'claim-completion',
    loadComponent: () =>
      import('./features/claim-completion/claim-completion.component')
        .then(m => m.ClaimCompletionComponent),
    canActivate: [sessionGuard, reloadGuard],
    data: {
      scrollPositionRestoration: 'top',
      breadcrumb: '請求完了'
    }
  },

  // ========================================
  // Standalone Routes
  // ========================================

  {
    path: 'example',
    loadComponent: () =>
      import('./core/examples/test.component')
        .then(m => m.ExampleComponent),
    data: { scrollPositionRestoration: 'top' }
  },

  // ========================================
  // Maintenance Page
  // ========================================
  {
    path: 'maintenance',
    loadComponent: () =>
      import('./features/maintenance/maintenance.component')
        .then(m => m.MaintenanceComponent),
    data: { scrollPositionRestoration: 'top' }
  },


  {
    path: 'system-maintenance',
    loadComponent: () =>
      import('./features/system-maintenance/system-maintenance.component')
        .then(m => m.SystemMaintenanceComponent),
    data: { scrollPositionRestoration: 'top' }
  },

  {
    path: 'browser-compatibility',
    component: BrowserCompatibilityComponent,
    data: { scrollPositionRestoration: 'top' }
  },

  {
    path: 'recommended-browser',
    component: RecommendedBrowserComponent,
    data: { scrollPositionRestoration: 'top' }
  },
  // ========================================
  // 404 Fallback
  // ========================================
  {
    path: '**',
    redirectTo: 'eclaim',
    pathMatch: 'full'
  }
];